import { useState, useEffect, useCallback } from "react"

import { Guid, ArticleAny } from "@/types"
import ArticleService from "services/ArticleService"

export default function useArticle(articleId?: Guid | null, onFail?: () => void) {
    const [article, setArticle] = useState<ArticleAny | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchArticle = useCallback(async (id: Guid) => {
        setIsLoading(true)
        setArticle(null)

        const fetchedArticle = await ArticleService.getArticle(id)

        setArticle(fetchedArticle)
        setIsLoading(false)

        if (!fetchedArticle && typeof onFail === "function") {
            onFail()
        }
    }, [onFail])

    const init = useCallback(() => {
        if (!articleId) {
            setArticle(null)
            setIsLoading(false)
            return
        }
        fetchArticle(articleId)
    }, [articleId, fetchArticle])

    useEffect(() => {
        init()
    }, [init])

    return {
        article,
        isLoading,
        refetchArticle: init,
    }
}
